import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function ReadyForYourProject() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="bereit-für-ihr-projekt" ref={ref} className={`dark bg-background text-foreground py-32 px-6 relative overflow-hidden flex flex-col items-center justify-center text-center transition-opacity duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      {}
      <span className="text-primary font-bold tracking-widest text-sm uppercase mb-6">
        Kontakt
      </span>

      {}
      <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-10 max-w-4xl">
        Bereit für Ihr Projekt?
      </h2>

      {}
      <Button asChild size="lg" className="group relative h-14 overflow-hidden rounded-full bg-primary px-10 text-lg font-semibold text-primary-foreground shadow-[0_0_20px_var(--color-primary)] transition-all duration-300 hover:bg-primary/90 hover:shadow-[0_0_40px_var(--color-primary)] hover:scale-105">
        <Link to="/ServicesPage">
          <span className="relative z-10 flex items-center gap-2">
            Projekt anfragen
            <ArrowRight className="size-5 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
          </span>
          <span className="absolute inset-0 -z-0 animate-pulse bg-white/20 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        </Link>
      </Button>
    </section>;
}